module.exports = __webpack_public_path__ + "img/104.8.60985c5b.png";